module.exports = __webpack_public_path__ + "static/media/BLK-BNB.149d7287.svg";